import { salutation, userJobTitleType, } from '../user/UserApi.js';
import { integerAsString, nonEmptyString, nullableDecimalAsString, nullableEnum, nullableString, } from '../validator.js';
export const customerUserModuleUrl = import.meta.url;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function customerUserPublicSearchRequestSchema() {
    return {
        type: 'array',
        minItems: 1,
        items: {
            type: 'object',
            additionalProperties: false,
            properties: {
                customerId: {
                    type: 'string',
                },
                userId: {
                    type: 'string',
                },
            },
            required: [
                'customerId',
                'userId',
            ],
        },
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function customerUserPublicSearchResponseSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            status: {
                const: 'ok',
            },
            list: {
                type: 'array',
                items: {
                    type: 'object',
                    additionalProperties: false,
                    properties: {
                        user: {
                            type: 'object',
                            additionalProperties: false,
                            properties: {
                                id: integerAsString(),
                                // TODO: should be required
                                salutation: nullableEnum(salutation),
                                title: nullableString(),
                                firstName: nonEmptyString(),
                                lastName: nonEmptyString(),
                                email: nonEmptyString(),
                                phone: nullableString(),
                                website: nullableString(),
                                jobTitleType: nullableEnum(userJobTitleType),
                                jobTitleFreetext: nullableString(),
                                avatar: nullableString(),
                                therapistProfileText: nullableString(),
                                therapeuticFocus: {
                                    type: 'array',
                                    items: {
                                        type: 'string',
                                    },
                                },
                                treatmentMethods: {
                                    type: 'array',
                                    items: {
                                        type: 'string',
                                    },
                                },
                                billingInformation: nullableString(),
                                vita: nullableString(),
                                languages: {
                                    type: 'array',
                                    items: {
                                        type: 'string',
                                    },
                                },
                            },
                            required: [
                                'id',
                                'salutation',
                                'title',
                                'firstName',
                                'lastName',
                                'email',
                                'phone',
                                'website',
                                'jobTitleType',
                                'jobTitleFreetext',
                                'avatar',
                                'therapistProfileText',
                                'therapeuticFocus',
                                'treatmentMethods',
                                'billingInformation',
                                'vita',
                                'languages',
                            ],
                        },
                        customer: {
                            type: 'object',
                            additionalProperties: false,
                            properties: {
                                id: integerAsString(),
                                name: nonEmptyString(),
                                city: {
                                    type: 'string',
                                },
                                postalCode: {
                                    type: 'string',
                                },
                                street: {
                                    type: 'string',
                                },
                                longitude: nullableDecimalAsString(),
                                latitude: nullableDecimalAsString(),
                            },
                            required: [
                                'id',
                                'name',
                                'city',
                                'postalCode',
                                'street',
                                'longitude',
                                'latitude',
                            ],
                        },
                    },
                    required: [
                        'user',
                        'customer',
                    ],
                },
            },
        },
        required: [
            'status',
            'list',
        ],
    };
}
export async function customerUserPublicSearch(baseUrl, props) {
    const result = await fetch(`${baseUrl}/api/customer-user/public-search`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(props),
    });
    if (result.status === 200) {
        return await result.json();
    }
    if (result.status === 400) {
        // TODO: validate
        return await result.json();
    }
    return {
        status: 'network error',
        httpStatus: result.status,
        message: await result.text(),
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function customerUserSearchResponseSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            list: {
                type: 'array',
                items: {
                    type: 'object',
                    additionalProperties: false,
                    properties: {
                        id: {
                            type: 'number',
                            minimum: 0,
                        },
                        customerId: {
                            type: 'number',
                            minimum: 0,
                        },
                        userId: {
                            type: 'number',
                            minimum: 0,
                        },
                        deactivated: {
                            type: 'boolean',
                        },
                        provider: nullableEnum([
                            'external',
                            'mollie',
                        ]),
                    },
                    required: [
                        'id',
                        'customerId',
                        'userId',
                        'deactivated',
                    ],
                },
                uniqueItems: true,
            },
        },
        required: [
            'list',
        ],
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function customerUserPatchRequestSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            deactivated: {
                type: 'boolean',
            },
        },
        required: [
            'deactivated',
        ],
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function customerUserPatchResponseSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            deactivated: {
                type: 'boolean',
            },
        },
        required: [
            'deactivated',
        ],
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function molliePaymentWebhookRequestSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            id: nonEmptyString(),
        },
        required: [
            'id',
        ],
    };
}
//# sourceMappingURL=CustomerUserApi.js.map